interface ImageParams {
  src: string;
  width: number;
  quality?: number;
}

export const getOptimizedImageUrl = ({ src, width }: ImageParams): string => {
  const quality = width < 1024 ? 60 : 75;
  const height = Math.round(width / 1.85);
  const baseUrl = src.startsWith('//') ? `https:${src}` : src;
  return `${baseUrl}?w=${width}&h=${height}&q=${quality}&fm=avif&fit=fill`;
};

export const filterConfigByAllowedKeys = (config: any, allowedKeys: string[]) => {
  return config ? Object.fromEntries(Object.entries(config).filter(([key]) => allowedKeys.includes(key))) : {};
};

/**
 * Calculates the CSS border radius value from a config value.
 * Returns "0" for SVG images, "50%" for "max", or a pixel value.
 * Returns undefined if the radius value is undefined.
 */
export const getBorderRadius = (
  radiusValue: string | number | undefined,
  isSvgImage: boolean
): string | undefined => {
  if (radiusValue === undefined) return undefined;
  if (isSvgImage) return "0";
  if (radiusValue === "max") return "50%";
  return `${radiusValue}px`;
};
